import {
  type UseMutationResult,
  useMutation,
  useQueryClient,
} from '@tanstack/react-query';
import api from '@/axios';
import { GET_PURCHASE_ORDER_KEY } from '@/keys';

const deletePurchaseOrderComment = async (id: number): Promise<void> => {
  const response = await api.delete(`/purchase-order-comments/${id}`);
  return response.data;
};

export function useDeletePurchaseOrderComment(
  purchaseOrderId: string,
): UseMutationResult<void, Error, number> {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: deletePurchaseOrderComment,
    onSuccess: async (_data) => {
      await queryClient.invalidateQueries({
        queryKey: [...GET_PURCHASE_ORDER_KEY, purchaseOrderId],
      });
    },
  });
}
